import { render, staticRenderFns } from "./XRayModal.vue?vue&type=template&id=739ff8e4"
import script from "./XRayModal.vue?vue&type=script&lang=js"
export * from "./XRayModal.vue?vue&type=script&lang=js"
import style0 from "./XRayModal.vue?vue&type=style&index=0&id=739ff8e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports